/**
 * Geometry of the floating action bar that hovers over the bottom of a list or a
 * task — the batch ActionPanel in the table views and the Triage quick-actions bar
 * in the task view. Both render the same shell, so both measure the same.
 *
 * Design spec (#2357) asks for a 16px gap below the bar and a 16px gap between the
 * bar and the last row. The spec quotes the bar as 66px, which is its inner box —
 * the shell adds a 4px frame on each side, so it renders 74px. Reserving 98px would
 * leave an 8px gap instead of the 16px asked for, so the reserved space is derived
 * from the rendered height here rather than hard-coded.
 */
export const FLOATING_ACTION_BAR_HEIGHT = 74;

/** Gap below the bar, and between the bar and the last row. */
export const FLOATING_ACTION_BAR_GAP = 16;

/**
 * Empty space to reserve under the last row so the bar never covers it.
 * Reserved unconditionally so rows don't jump when a selection toggles.
 */
export const FLOATING_ACTION_BAR_SPACE = FLOATING_ACTION_BAR_HEIGHT + FLOATING_ACTION_BAR_GAP * 2;
